import { keepPreviousData } from "@tanstack/react-query"

import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_HORIZONTAL_SIGNING } from "../../../../../common/constants/modules"

import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"

export function useHorizontalSigningGrades(config = {}, parameters = {}) {
    const url = "horizontal_signs/stats/conditions/"

    const queryParameters = useExtendWithSubnetworks(parameters, API_MODULE_HORIZONTAL_SIGNING)
    const queryKey = horizontalSigningQueryKeys["stats_conditions"](queryParameters)

    return useHorizontalSigningQuery(
        url,
        queryKey,
        queryParameters,
        {
            ...config,
            placeholderData: keepPreviousData,
        },
    )
}
